import { brandName, heroStats, heroTags, tickerItems } from '@/mocks/clearing';

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute -right-32 top-[-120px] h-[420px] w-[420px] rounded-full bg-accent-100/60 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-24 bottom-[-160px] h-[360px] w-[360px] rounded-full bg-primary-100/50 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-[1180px] px-4 pb-14 pt-14 md:px-6 md:pb-20 md:pt-20">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-10">
          <div data-reveal className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 font-label text-[11px] tracking-[0.18em] text-primary-700">
              <i className="ri-bookmark-3-line text-xs" />
              澄清 · 辟谣 · 反转台账
            </span>

            <h1 className="mt-6 font-heading text-[44px] font-bold leading-[1.05] tracking-tight text-foreground-950 md:text-[64px] lg:text-[72px]">
              {brandName}
            </h1>

            <p className="mt-5 font-heading text-lg leading-relaxed text-foreground-800 md:text-xl">
              洗白还是实锤，看完整时间线再站队。
            </p>

            <p className="mt-4 max-w-xl text-sm leading-[1.9] text-foreground-600 md:text-[15px]">
              黑料学生带来学生黑料澄清与辟谣专区，跟进反转、真相与当事人回应。
              我们不急着下结论，只把每一句流传的说法、每一份可核对的材料，按时间顺序摊开，
              让你自己判断这到底是澄清，还是洗白。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-3 py-1.5 font-label text-xs text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#ranking"
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 font-label text-sm font-medium text-background-50 transition-colors duration-200 dark:text-foreground-950 hover:bg-primary-600"
              >
                <i className="ri-fire-line text-base" />
                查看今日澄清热度榜
              </a>
              <a
                href="#timeline"
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100/70 px-7 font-label text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-timeline-view text-base" />
                还原反转时间线
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-8 sm:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 font-label text-xs text-foreground-500">
                    {stat.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div data-reveal className="lg:col-span-5">
            <div className="relative mx-auto max-w-[420px] lg:max-w-none">
              <div className="relative h-[340px] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20editorial%20magazine%20still%20life%20with%20stacked%20newspapers%2C%20amber%20desk%20lamp%20glow%2C%20ceramic%20cup%20and%20open%20notebook%20on%20a%20cream%20textured%20table%2C%20soft%20natural%20window%20light%2C%20muted%20terracotta%20and%20ochre%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=1000&seq=hls-hero-01&orientation=portrait"
                  alt="黑料学生澄清专题使用的暖色调编辑台场景"
                  title="黑料学生澄清 辟谣 反转台账"
                  className="h-full w-full object-top"
                />
              </div>

              <div className="absolute -bottom-8 -left-4 hidden h-[150px] w-[150px] overflow-hidden rounded-lg border-4 border-background-50 sm:block md:h-[170px] md:w-[170px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20magnifying%20glass%20resting%20over%20blurred%20printed%20documents%20on%20a%20warm%20beige%20desk%2C%20soft%20afternoon%20light%2C%20muted%20ochre%20and%20clay%20color%20palette%2C%20editorial%20still%20life%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=hls-hero-02&orientation=squarish"
                  alt="用放大镜核对网传截图细节"
                  title="黑料学生 截图鉴定 辟谣"
                  className="h-full w-full object-top"
                />
              </div>

              <div className="hx-float absolute -right-3 top-6 rounded-md border border-background-200 bg-background-50 px-4 py-3 shadow-none md:-right-6">
                <p className="font-label text-[10px] tracking-[0.2em] text-foreground-500">
                  今日复核
                </p>
                <p className="mt-1 font-heading text-xl font-bold text-primary-600">
                  12 <span className="text-sm font-medium text-foreground-500">条</span>
                </p>
              </div>

              <div className="absolute -bottom-5 right-4 rounded-md bg-accent-500 px-4 py-2.5">
                <p className="font-label text-[11px] font-medium text-accent-950">
                  已标注反转节点 5 处
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-y border-background-200 bg-background-100/80 py-4">
        <div className="flex w-max hx-marquee items-center gap-10 pl-4">
          {[...tickerItems, ...tickerItems].map((item, index) => (
            <span
              key={`${item}-${index}`}
              className="flex items-center gap-3 whitespace-nowrap font-label text-[13px] text-foreground-600"
            >
              <i className="ri-flashlight-line text-accent-600" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}